import { gql } from '@apollo/client';
export const JOB = gql `
  query job($workflow_id: Int!) {
    wft_job(where: { workflows: { id: { _eq: $workflow_id } } }) {
      title
      description
    }
  }
`;
